const CARDS = [
  {
    title: '霸道总裁的甜蜜契约',
    desc: '她只是一个小职员，却意外成为霸道总裁的契约女友。本以为只是演戏，却一步步沦陷在他的温柔里……',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20manga%20style%20illustration%20of%20a%20handsome%20businessman%20in%20a%20luxury%20office%20with%20a%20gentle%20expression%2C%20warm%20golden%20lighting%2C%20romantic%20atmosphere%2C%20clean%20shoujo%20art%20style%2C%20peach%20and%20cream%20tones%2C%20simple%20background&width=600&height=800&seq=card-01&orientation=portrait',
    tag: '甜宠恋爱', tagColor: 'bg-primary-100 text-primary-700',
    stat: '9.8分', statIcon: 'ri-star-fill',
    chapters: '128话',
  },
  {
    title: '校草大人请多指教',
    desc: '转学第一天就被校草盯上了？他的温柔只对她一个人，全校女生的公敌她当定了！',
    img: 'https://readdy.ai/api/search-image?query=Handsome%20anime%20school%20boy%20in%20uniform%20leaning%20against%20a%20window%20with%20soft%20sunlight%2C%20warm%20gentle%20expression%2C%20clean%20shoujo%20manga%20style%2C%20peach%20and%20cream%20colors%2C%20simple%20school%20background&width=600&height=800&seq=card-02&orientation=portrait',
    tag: '校园纯爱', tagColor: 'bg-accent-100 text-accent-700',
    stat: '9.7分', statIcon: 'ri-star-fill',
    chapters: '95话',
  },
  {
    title: '青梅竹马的恋爱日记',
    desc: '从小一起长大的两个人，什么时候友情变成了爱情？最温暖的竹马恋爱故事。',
    img: 'https://readdy.ai/api/search-image?query=Cute%20anime%20illustration%20of%20childhood%20friends%20sharing%20an%20umbrella%20in%20the%20rain%2C%20warm%20and%20sweet%20atmosphere%2C%20soft%20pastel%20colors%2C%20clean%20manga%20style%2C%20simple%20rainy%20street%20background&width=600&height=800&seq=card-03&orientation=portrait',
    tag: '治愈漫画', tagColor: 'bg-secondary-100 text-secondary-700',
    stat: '9.6分', statIcon: 'ri-star-fill',
    chapters: '76话',
  },
  {
    title: '我的恶魔男友',
    desc: '普通女高中生意外与恶魔签订契约，却发现这个恶魔男友意外地温柔又专一。',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20anime%20boy%20with%20dark%20hair%20and%20gentle%20red%20eyes%20in%20a%20moonlit%20scene%2C%20romantic%20fantasy%20atmosphere%2C%20soft%20dark%20and%20warm%20contrast%2C%20clean%20manga%20style%2C%20simple%20background&width=600&height=800&seq=card-04&orientation=portrait',
    tag: '奇幻恋爱', tagColor: 'bg-primary-100 text-primary-700',
    stat: '9.5分', statIcon: 'ri-star-fill',
    chapters: '112话',
  },
  {
    title: '樱花树下的约定',
    desc: '高三最后一年，她在樱花树下遇到了转校生。一场关于青春和约定的纯爱故事就此展开。',
    img: 'https://readdy.ai/api/search-image?query=Beautiful%20anime%20illustration%20of%20a%20girl%20standing%20under%20a%20blooming%20cherry%20tree%20in%20spring%2C%20soft%20pink%20petals%20falling%2C%20warm%20sunlight%2C%20clean%20shoujo%20manga%20style%2C%20simple%20background&width=600&height=800&seq=card-05&orientation=portrait',
    tag: '校园纯爱', tagColor: 'bg-accent-100 text-accent-700',
    stat: '9.4分', statIcon: 'ri-star-fill',
    chapters: '53话',
  },
  {
    title: '总裁大人有点甜',
    desc: '相亲遇到顶头上司是什么体验？冷面总裁在她面前却变得又甜又宠，办公室恋情甜度爆表。',
    img: 'https://readdy.ai/api/search-image?query=Stylish%20anime%20illustration%20of%20a%20couple%20in%20modern%20office%20attire%20sharing%20a%20coffee%20break%2C%20warm%20lighting%2C%20romantic%20workplace%20atmosphere%2C%20clean%20manga%20style%2C%20peach%20tones%2C%20simple%20background&width=600&height=800&seq=card-06&orientation=portrait',
    tag: '甜宠恋爱', tagColor: 'bg-primary-100 text-primary-700',
    stat: '9.3分', statIcon: 'ri-star-fill',
    chapters: '89话',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="section-padding bg-background-50">
      <div className="section-container">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            精选推荐
          </h2>
          <p className="text-foreground-600 mt-2 text-sm md:text-base">本周必看甜蜜漫画精选</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {CARDS.map((card, idx) => (
            <a
              key={idx}
              href="#cards"
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative h-72 overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${card.tagColor}`}>{card.tag}</span>
                </div>
                <div className="absolute top-3 right-3 flex items-center gap-1 px-2.5 py-1 rounded-full bg-black/40 backdrop-blur-sm text-white text-xs font-bold">
                  <i className={`${card.statIcon} text-accent-400 text-xs`}></i>
                  {card.stat}
                </div>
              </div>
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="text-sm font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-2 line-clamp-3 leading-relaxed flex-1">{card.desc}</p>
                <div className="mt-3 flex items-center justify-between">
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-book-open-line"></i> 共{card.chapters}
                  </span>
                  <span className="text-xs text-primary-500 font-medium flex items-center gap-1">
                    开始阅读 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}